export const USERS_API = '/api/users';

export const USER_ROLE_API = '/api/users/me/roles';
